import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getAttributeById({ commit, state }, { id }) {
    try {
      let attribute = (state.attributtes || []).find((p) => p.id === id);
      if (!attribute) {
        let response = await requestAxios({
          url: `/awy/api/v1/ecommerce/attribute/${id}`,
          method: "GET",
        });
        attribute = response.data.data;
      }
      commit(MutationsType.SET_ATTRIBUTE, attribute);
    } catch (error) {
      console.error("getAttributeById: ", error);
      throw error.response.data;
    }
  },
  async getAllAttributes({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/attribute",
        method: "GET",
      });
      commit(MutationsType.SET_ATTRIBUTES, response.data.data);
    } catch (error) {
      console.error("getAllAttributes: ", error);
      throw error.response.data;
    }
  },
  async saveAttribute({ commit }, payload) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/ecommerce/attribute",
        method: "POST",
        data: payload,
      });
      commit(MutationsType.ADD_ATTRIBUTE, response.data.data);
    } catch (error) {
      console.error("saveAttribute: ", error);
      throw error.response.data;
    }
  },
  async updateAttribute({ commit }, { id, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/ecommerce/attribute/${id}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_ATTRIBUTE, response.data.data);
    } catch (error) {
      console.error("updateAttribute: ", error);
      throw error.response.data;
    }
  },
  async deleteAttribute({ commit }, { id }) {
    try {
      await requestAxios({
        url: `/awy/api/v1/ecommerce/attribute/${id}`,
        method: "DELETE",
      });
      commit(MutationsType.DELETE_ATTRIBUTE, { id });
    } catch (error) {
      console.error("deleteAttribute: ", error);
      throw error.response.data;
    }
  },
  resetAttribute({ commit }) {
    commit(MutationsType.SET_ATTRIBUTE, null);
  },
  resetModuleCatalogAttribute({ commit }) {
    commit(MutationsType.SET_ATTRIBUTE, null);
    commit(MutationsType.SET_ATTRIBUTES, null);
  },
};
